module.exports = __webpack_public_path__ + "static/media/ic-chatbot@2x.ba30a256.png";